<template>
  <el-container>
    <el-main>
      <h3 class="heading">Edit integration format</h3>
      <el-card>
        <IntegrationForm
          v-if="feedFormat"
          v-model="feedFormat"
          :loading="loading"
          action-text="Update"
          @submit="onSubmit"
        />
      </el-card>
      <LoadingBlock :loading="fetchingFeedFormat" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useFeedFormatsStore } from '@/apps/traforama/store/feedFormats'
import { FeedFormatValidationErrorsKey } from '@/api/types'
import { IFeedFormatAttributes } from '@/apps/traforama/interfaces/feedFormats'
import useRouter from '@/hooks/useRouter'
import { ElMessage } from 'element-plus'
import IntegrationForm from '../components/IntegrationForm.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import useValidation from '@/hooks/useValidation'
import useFetchFeedFormat from '@/hooks/useFetchFeedFormat'
import { safeSubmitProcessing } from '@/utils/helpers'

export default defineComponent({
  name: 'EditFeedFormat',
  components: {
    IntegrationForm,
    LoadingBlock
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const feedFormatsStore = useFeedFormatsStore()
    const { provideValidation, setValidationErrors } = useValidation(
      FeedFormatValidationErrorsKey
    )
    const errors = provideValidation()

    const loading = ref(false)
    const { router } = useRouter()

    const { feedFormat, fetchingFeedFormat, FetchItem } = useFetchFeedFormat()

    FetchItem(props.id)

    const onSuccess = async () => {
      await router.push('/integrations')
      ElMessage.success({ message: 'Integration format has been updated' })
    }

    const onSubmit = async ({
      feedFormat
    }: {
      feedFormat: IFeedFormatAttributes
    }) => {
      await safeSubmitProcessing(
        loading,
        () => feedFormatsStore.SaveItem(feedFormat),
        () => onSuccess(),
        (err) => setValidationErrors(err, errors)
      )
    }

    return { feedFormat, loading, onSubmit, fetchingFeedFormat }
  }
})
</script>
